import React from "react";
import { Lock, Clock } from "lucide-react";
import { useT } from "@/lib/LanguageContext";
import { adminHref } from "../adminPath";

/**
 * Inline counterpart of RequireCapability's panel, for a page that stays open but has
 * ONE surface the plan withholds (e.g. telehealth: the consult list stays, creating new
 * video business does not).
 *
 * `state` is `useEntitlements().status(key)`. Renders nothing for "granted" and for
 * `null` (the map is not known yet) — an unknown plan is never stated as a refusal.
 * `body` is the caller's already-resolved sentence saying WHAT is withheld on its page.
 */
export default function CapabilityNotice({ state, eta, body, testId }) {
  const t = useT("admin");
  if (state !== "not_in_plan" && state !== "coming_soon") return null;
  const comingSoon = state === "coming_soon";
  const Icon = comingSoon ? Clock : Lock;
  return (
    <div
      role="status"
      data-testid={testId}
      className="rounded-2xl border border-eh-border-soft bg-eh-cream/60 px-4 py-3 text-sm text-eh-ink flex items-start gap-2"
    >
      <Icon className="w-4 h-4 flex-shrink-0 mt-0.5" />
      <div className="min-w-0">
        <strong className="block">{comingSoon ? t("ent.comingSoon.title") : t("ent.notInPlan.title")}</strong>
        {body && <span className="block mt-0.5 text-eh-muted">{body}</span>}
        {comingSoon && eta && <span className="block mt-0.5 text-eh-muted">{t("ent.comingSoon.eta", { eta })}</span>}
        {!comingSoon && (
          // A plain anchor: must resolve on the platform host and on a tenant host.
          <a href={adminHref("/admin/billing")} data-testid={`${testId}-billing`} className="inline-block mt-1 font-semibold underline">
            {t("ent.notInPlan.cta")}
          </a>
        )}
      </div>
    </div>
  );
}
